module.exports = __webpack_public_path__ + "static/media/icon-close-popup.fffb14e4.svg";